<template>
  <div class="finish_homework">
    <div class="flex Flexalign cursor_pointer back_box FlexEnd FlexjustifyEnd" @click="goBack">
      <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
      <div class="mar_left_10">返回</div>
    </div>
    <div class="finish_list" v-if="stage == 2">
      <div class="finish_one flex">
        <div class="finish_num">序号</div>
        <div class="finish_name">作业名称</div>
        <div class="finish_name">作业描述</div>
        <div class="finish_state">状态</div>
        <div class="finish_option">操作</div>
      </div>
      <div class="finish_one flex" v-for="(item, index) in finishList" :key="index"
        :class="[index % 2 == 1 ? 'finish_one_active' : '']">
        <div class="finish_num">{{ index + 1 }}</div>
        <div class="finish_name">{{ item.examName }}</div>
        <div class="finish_name">{{ item.examDetail }}</div>
        <div class="finish_state" :class="[item.state == 1 ? 'state_green' : 'state_orange']">
          {{
            item.isCorrect == 1 ? "已完成" : item.isCorrect == 2 ? "待批阅" : ""
          }}
        </div>
        <div class="finish_option cursor_pointer flex Flexalign" @click="goHomeworkDetail(item)">
          详情
          <!-- <el-dropdown @command="handleCommandOption">
            <span class="el-dropdown-link">
              <el-icon><MoreFilled /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="detail">详情</el-dropdown-item>
                <el-dropdown-item command="download">试卷下载</el-dropdown-item>
              </el-dropdown-menu>
            </template>
</el-dropdown> -->
        </div>
      </div>
    </div>
    <homework-detail v-if="stage == 1" :paperInfo="paperInfo" @goBack="goBack"
      :homeworkType="homeworkType"></homework-detail>

    <customizeHomework ref="customizeHomeworkVue" v-if="stage == 3 && homeworkType != 'afterHomework'"
      :examInfo="paperInfo" @goBack="goBack" :homeworkType="homeworkType"></customizeHomework>
    <afterHomeworkCustomize ref="afterHomeworkCustomize" v-if="stage == 3 && homeworkType == 'afterHomework'"
      :examInfo="paperInfo" @goBack="goBack" :homeworkType="homeworkType"></afterHomeworkCustomize>
  </div>
</template>

<script>
import homeworkDetail from "./homeworkDetail.vue";
import customizeHomework from "./customizeHomework.vue";
import { mapState } from "vuex";
import afterHomeworkCustomize from '../afterHomeworkCustomize.vue';
export default {
  name: "GjkcH5MyFinishHomework",
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      courseRound: (state) => state.learning.courseRound,
    }),
  },
  props: {
    homeworkType: {}
  },
  inject: ["practiceBack", "updateShowPractice", "showWrongQuestion"],

  components: { homeworkDetail, customizeHomework, afterHomeworkCustomize },
  data() {
    return {
      finishList: [],
      stage: "",
      paperInfo: {},
      listQuery: {
        chapterId: "",
        schemeId: "",
        roundId: "",
        examScenes: [3],
      },
    };
  },
  mounted() {
    // if(this.stage == 2){
    this.getMyFinishedHomework();
    // }
  },

  methods: {
    goBack() {
      if (this.stage == 1 || this.stage == 2 || this.stage == 3) {
        this.$emit("showHomework", false);
      }
    },
    handleCommandOption(command) {
      if (command == "detail") {
        // this.stage++;
      } else if (command == "download") {
        console.log(111);
      }
    },
    // 获取已完成的作业列表
    getMyFinishedHomework() {
      if (this.$Tools.empty(this.selectLearningInfo)) return;
      this.listQuery.chapterId =
        this.selectLearningInfo?.chapterId;
      this.listQuery.schemeId = this.selectLearningInfo?.schemeId;
      this.listQuery.roundId = this.selectLearningInfo?.roundId;
      this.$Api.exam
        .getMyFinishedHomework(this.listQuery)
        .then((res) => {
          this.finishList = res.data.data;
        })
        .catch(() => { });
    },
    goHomeworkDetail(info) {
      if (info.isCorrect == 2) {
        this.$Dialog.toast("请等待老师的批阅");
      } else {
        this.$Api.exam
          .getPaperRecordInfo(info.recordId)
          .then((res) => {
            this.showWrongQuestion(true, res.data.data, false, true);
          })
          .catch(() => { });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.finish_homework {
  .back_box {
    width: 100%;
    font-size: 18px;
    color: #13d6aa;

    .back_icon {
      width: 24px;
      height: 24px;
    }
  }

  .finish_list {
    .finish_one {
      font-size: 14px;
      color: #111111;
      text-align: start;
      height: 45px;
      line-height: 45px;

      .finish_num {
        width: 10%;
        text-align: center;
      }

      .finish_name {
        width: 35%;
      }

      .finish_state {
        width: 10%;
      }

      .state_green {
        color: rgba(19, 214, 170, 1);
      }

      .state_orange {
        color: rgba(255, 107, 0, 1);
      }

      .finish_option {
        width: 10%;
      }
    }

    .finish_one_active {
      background: #f7f7fa;
    }
  }
}
</style>
